// extracted by mini-css-extract-plugin
export var share = "index-module--share--bZVz+";
export var share_title = "index-module--share_title--L5BrJ";
export var share_buttons = "index-module--share_buttons--y2nif";
export var icon = "index-module--icon--1OOpl";